/* eslint-disable import/no-cycle */
import { useTranslation } from 'react-i18next';
import { Table } from 'semantic-ui-react';

import { IReportFilterParamsProps } from '../../../../types/filters';
import { Report } from '../../../../types/report';
import { SubTableRow } from './components/SubTableRow';

interface SubTableProps {
  query: IReportFilterParamsProps;

  reports?: Report[];
}

export function SubTable({ query, reports }: SubTableProps) {
  const { t } = useTranslation();
  return (
    <Table.Cell colSpan="99">
      <Table
        unstackable
        compact
        style={{
          borderRadius: '5px',
          border: '1px solid #00000010',
          boxShadow: '2px 2px 2px #00000010',
        }}
      >
        <Table.Header>
          <Table.Row className="subthead">
            <Table.HeaderCell className="th" />

            <Table.HeaderCell className="th" content="Name" />

            {reports?.[0]?.values?.map(({ trainingType }) => (
              <Table.HeaderCell
                key={trainingType}
                className="th"
                content={trainingType}
                textAlign="center"
              />
            ))}

            <Table.HeaderCell
              className="th"
              content={t('pages.reports.associateTotal')}
              textAlign="center"
            />

            <Table.HeaderCell
              className="th"
              content={t('pages.reports.totalImmediate')}
              textAlign="center"
            />

            <Table.HeaderCell
              className="th"
              content={t('pages.reports.generalTotalArea')}
              textAlign="center"
            />
          </Table.Row>
        </Table.Header>

        {reports?.map((report) => (
          <SubTableRow key={report.employee.za} query={query} report={report} />
        ))}
      </Table>
    </Table.Cell>
  );
}
